<div class="title-container">
  <span class="title">SOAP-Request</span>
  <span class="subtitle">for SmartDocuments</span>
</div>
<button mat-flat-button color="primary" (click)="ToggleDrawer()">
  <span>More info</span>
  <mat-icon>help</mat-icon>
</button>
